<script lang="ts">
  import dayjs from 'dayjs'
  import advancedFormat from 'dayjs/plugin/advancedFormat'
  import dayoOfYear from 'dayjs/plugin/dayOfYear'

  dayjs.extend(dayoOfYear)
  dayjs.extend(advancedFormat)

  export let timestamp
  export let dateOnly = false
  export let timeOnly = false

  const now = dayjs()
  const gameDay = dayjs(timestamp)

  const diff = gameDay.dayOfYear() - now.dayOfYear()
  const prefix =
    diff === 0 ? 'Today' : diff === 1 ? 'Tomorrow' : gameDay.format('MMM D')
</script>

{#if dateOnly}
  {prefix}
{:else if timeOnly}
  {gameDay.format('h:mm A')}
{:else}
  {`${prefix} ${gameDay.format('h:mm A')}`}
{/if}
